<template>
  <div class="fab" :style="fab_style + position_adapted + small_adapted">
      <i class="fal" :class="icon_adapted"></i>
  </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: "plus"
        },
        background: {
            type: String,
            default: "transparent"
        },
        color: {
            type: String,
            default: "#000000"
        },
        position: {
            type: String,
            required: false
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        icon_adapted() {
            return "fa-" + this.icon;
        },
        fab_style() {
            return "background:" + this.background + ";color:" + this.color + ";";
        },
        position_adapted() {
            switch (this.position) {
                case "bottom_right":
                    return "position:absolute;bottom:20px;right:20px;";
                default: 
                    return "";
            }
        },
        small_adapted() {
            return this.small ? "border-radius:40px;width:40px;height:40px;font-size:18px;padding-top:12px;" : "";
        }
    }
}
</script>

<style>
.fab {
    border-radius: 60px;
    width: 60px;
    height: 60px;
    font-size: 25px;
    padding-top: 18px;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    text-shadow:0 2px 10px rgba(0,0,0,1), 3px 5px 20px rgba(0,0,0,.2);
}
</style>